import { render, staticRenderFns } from "./ReferenceTableFieldPicker.vue?vue&type=template&id=a61791ec&scoped=true&"
import script from "./ReferenceTableFieldPicker.vue?vue&type=script&lang=js&"
export * from "./ReferenceTableFieldPicker.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTableFieldPicker.vue?vue&type=style&index=0&id=a61791ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61791ec",
  null
  
)

export default component.exports